/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ClientProductDto,
  GetClientProductsParams
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType } from '../../orval-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />
 */
export const getClientProductById = (
    userId: string,
    clientId: number,
    productId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ClientProductDto>(
      {url: `/api/${userId}/clients/${clientId}/products/${productId}`, method: 'GET', signal
    },
      options);
    }




export const getGetClientProductByIdQueryKey = (userId: string,
    clientId: number,
    productId: number,) => {
    return [
    `/api/${userId}/clients/${clientId}/products/${productId}`
    ] as const;
    }


export const getGetClientProductByIdQueryOptions = <TData = Awaited<ReturnType<typeof getClientProductById>>, TError = ErrorType<unknown>>(userId: string,
    clientId: number,
    productId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientProductById>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientProductByIdQueryKey(userId,clientId,productId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientProductById>>> = ({ signal }) => getClientProductById(userId,clientId,productId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId && clientId && productId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClientProductById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClientProductByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getClientProductById>>>
export type GetClientProductByIdQueryError = ErrorType<unknown>


export function useGetClientProductById<TData = Awaited<ReturnType<typeof getClientProductById>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number,
    productId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientProductById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientProductById>>,
          TError,
          Awaited<ReturnType<typeof getClientProductById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientProductById<TData = Awaited<ReturnType<typeof getClientProductById>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number,
    productId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientProductById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientProductById>>,
          TError,
          Awaited<ReturnType<typeof getClientProductById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientProductById<TData = Awaited<ReturnType<typeof getClientProductById>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number,
    productId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientProductById>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetClientProductById<TData = Awaited<ReturnType<typeof getClientProductById>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number,
    productId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientProductById>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetClientProductByIdQueryOptions(userId,clientId,productId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_REPORT_ADMIN**<br /><br />Assign product to client
 */
export const assignProductToClient = (
    userId: string,
    clientId: number,
    productId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ClientProductDto>(
      {url: `/api/${userId}/clients/${clientId}/products/${productId}`, method: 'PUT', signal
    },
      options);
    }



export const getAssignProductToClientMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignProductToClient>>, TError,{userId: string;clientId: number;productId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof assignProductToClient>>, TError,{userId: string;clientId: number;productId: number}, TContext> => {

const mutationKey = ['assignProductToClient'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignProductToClient>>, {userId: string;clientId: number;productId: number}> = (props) => {
          const {userId,clientId,productId} = props ?? {};

          return  assignProductToClient(userId,clientId,productId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignProductToClientMutationResult = NonNullable<Awaited<ReturnType<typeof assignProductToClient>>>

    export type AssignProductToClientMutationError = ErrorType<unknown>

    export const useAssignProductToClient = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignProductToClient>>, TError,{userId: string;clientId: number;productId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignProductToClient>>,
        TError,
        {userId: string;clientId: number;productId: number},
        TContext
      > => {
      return useMutation(getAssignProductToClientMutationOptions(options), queryClient);
    }
    /**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_REPORT_ADMIN**<br /><br />Unassign product from client
 */
export const unassignProductFromClient = (
    userId: string,
    clientId: number,
    productId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/${userId}/clients/${clientId}/products/${productId}`, method: 'DELETE', signal
    },
      options);
    }



export const getUnassignProductFromClientMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unassignProductFromClient>>, TError,{userId: string;clientId: number;productId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof unassignProductFromClient>>, TError,{userId: string;clientId: number;productId: number}, TContext> => {

const mutationKey = ['unassignProductFromClient'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unassignProductFromClient>>, {userId: string;clientId: number;productId: number}> = (props) => {
          const {userId,clientId,productId} = props ?? {};

          return  unassignProductFromClient(userId,clientId,productId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnassignProductFromClientMutationResult = NonNullable<Awaited<ReturnType<typeof unassignProductFromClient>>>

    export type UnassignProductFromClientMutationError = ErrorType<unknown>

    export const useUnassignProductFromClient = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unassignProductFromClient>>, TError,{userId: string;clientId: number;productId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unassignProductFromClient>>,
        TError,
        {userId: string;clientId: number;productId: number},
        TContext
      > => {
      return useMutation(getUnassignProductFromClientMutationOptions(options), queryClient);
    }
    /**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />
 */
export const getClientProducts = (
    userId: string,
    clientId: number,
    params?: GetClientProductsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ClientProductDto[]>(
      {url: `/api/${userId}/clients/${clientId}/products`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetClientProductsQueryKey = (userId: string,
    clientId: number,
    params?: GetClientProductsParams,) => {
    return [
    `/api/${userId}/clients/${clientId}/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetClientProductsQueryOptions = <TData = Awaited<ReturnType<typeof getClientProducts>>, TError = ErrorType<unknown>>(userId: string,
    clientId: number,
    params?: GetClientProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientProducts>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientProductsQueryKey(userId,clientId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientProducts>>> = ({ signal }) => getClientProducts(userId,clientId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId && clientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClientProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClientProductsQueryResult = NonNullable<Awaited<ReturnType<typeof getClientProducts>>>
export type GetClientProductsQueryError = ErrorType<unknown>


export function useGetClientProducts<TData = Awaited<ReturnType<typeof getClientProducts>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number,
    params: undefined |  GetClientProductsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientProducts>>,
          TError,
          Awaited<ReturnType<typeof getClientProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientProducts<TData = Awaited<ReturnType<typeof getClientProducts>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number,
    params?: GetClientProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientProducts>>,
          TError,
          Awaited<ReturnType<typeof getClientProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientProducts<TData = Awaited<ReturnType<typeof getClientProducts>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number,
    params?: GetClientProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientProducts>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetClientProducts<TData = Awaited<ReturnType<typeof getClientProducts>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number,
    params?: GetClientProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientProducts>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetClientProductsQueryOptions(userId,clientId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






